import Ajax from '../../../../util/ajax';
export function zigbeeMoveToClosestFrequency(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/8/command/move-to-closest-frequency';
        const value = {
            'frequency': payload.frequency
        };
        ajax.post(url, value);
    };
}
